import type { Card } from '@/types/card';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useShareProfile = (card: Card | null) => {
  const { t } = useTranslation();
  const shareProfile = async () => {
    const profileUrl = window.location.href;

    if (navigator.share) {
      try {
        const shareData: ShareData = {
          title: t('digitalCard:share.title', { name: card?.full_name }),
          text: t('digitalCard:share.text', { name: card?.full_name }),
          url: profileUrl,
        };

        if (card?.avatar) {
          try {
            const response = await fetch(card.avatar);
            const blob = await response.blob();
            const file = new File([blob], 'profile.jpg', {
              type: 'image/jpeg',
            });
            shareData.files = [file];
          } catch (error) {
            console.error(
              "Erreur lors de la récupération de l'image pour le partage:",
              error,
            );
          }
        }

        await navigator.share(shareData);
      } catch (error) {
        console.error('Erreur lors du partage', error);
        // Fallback au copier-coller si le partage échoue
        navigator.clipboard.writeText(profileUrl);
        toast.success(t('digitalCard:share.success'));
      }
    } else {
      navigator.clipboard.writeText(profileUrl);
      toast.success(t('digitalCard:share.success'));
    }
  };

  return { shareProfile };
};
